import { CurrentUser } from "../../model/CurrentUser";

const IF = require( "infrontjs" );

import template from './LoginTemplate.html';
import { IndexState } from "../index/IndexState";

export class LoginState extends IF.State
{
    static ROUTE = '/login';
    static ID = 'login';

    canEnter()
    {
        return ( this.app.currentUser === null );
    }

    getRedirectUrl()
    {
        return IndexState.ROUTE;
    }

    async enter()
    {
        this.app.container.innerHTML =  this.app.view.getHtml(
            template,
            {
                isFromSoi : this.app.storage.loadIsSoi()
            }
        );

        this.app.container.querySelector( '[data-id="btn-login"]' ).addEventListener( 'click', async ( btn ) => {
            const errContainer = this.app.container.querySelector( '[data-id="error-container"]' );
            errContainer.classList.add( 'hidden' );
            const form = this.app.container.querySelector( 'form[data-id="login-form"]' );
            form.classList.add( 'validated' );
            if ( true === form.checkValidity() )
            {
                const formData = IF.Helper.serializeForm( form );
                let response = null;
                try
                {
                    response = await this.app.api.post( '/auth/session', formData );
                }
                catch( e )
                {
                    response = null;
                }
                let errMsg = 'Ein Fehler ist aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt erneut';
                if ( response )
                {
                    switch ( response.status )
                    {
                        case 201:
                            const data = await response.json();
                            if ( data && data.hasOwnProperty( 'token' ) && data.hasOwnProperty( 'user' ) )
                            {
                                this.app.storage.saveIsKnown( true );
                                this.app.storage.saveSessionToken( data.token );
                                this.app.api.setSessionToken( data.token );
                                this.app.currentUser = new CurrentUser( data.user );
                                this.app.router.redirect( '/' );

                                /*
                                setTimeout( () => {
                                    try {
                                        if ( false === this.app.isNativeMobile() )
                                        {
                                            OneSignal.Slidedown.promptPush();
                                        }
                                    } catch ( e ) { }
                                }, 2000 );
                                 */
                            }
                        break;

                        case 404:
                            errMsg = 'Fehlerhafte Anmeldedaten.';
                        break;
                        case 403:
                            const reason = await response.json();
                            if ( reason && reason.message )
                            {
                                switch ( reason.message )
                                {
                                    case 'invalid':
                                        errMsg= 'Fehlerhafte Anmeldedaten.';
                                    break;

                                    case 'not_validated':
                                        errMsg = 'E-Mail Adresse nicht validiert.';
                                    break;

                                    case 'blocked':
                                    case 'banned':
                                    break;
                                }
                            }
                        break;
                    }
                }
                errContainer.querySelector( '[data-id="error-text"]' ).innerHTML = errMsg;
                errContainer.classList.remove( 'hidden' );
            }

        });
    }

    async exit()
    {
        this.app.container.querySelector( '[data-id="btn-login"]' ).removeEventListeners( 'click' );
    }
};
